import Reflux from 'reflux';

export default {
  notifyChangesResults: Reflux.createAction({ sync: false }),
};
